<template>
    <div class="chat-window d-flex flex-column h-100">
        <chat-header
            :user="conversation.flexworker"
            :chatId="conversation.chat ? conversation.chat.id : null"
            :status="conversation.chat ? conversation.chat.status : 'new'"
            :readOnly="true"
        />
        <p v-if="isReadOnly" class="conversation-note mt-3 mb-0 px-2">{{ readOnlyNote }}</p>
        <div class="messages-container mt-4 mb-4">
            <p v-if="isDraft" class="conversation-note px-2">No conversation yet. Send the first message to start one.</p>
            <chat-messages v-else :messages="conversation.messages" :isWorkfixLine="Boolean(conversation.chat && conversation.chat.is_workfix_line)" />
        </div>
        <p v-if="sendFailure" class="send-failure mb-2 px-2">{{ sendFailure }}</p>
        <template v-if="canStartNew">
            <p v-if="isHistory" class="conversation-note mb-2 px-2">This conversation is archived. Sending a message reopens it.</p>
            <chat-input
                status="open"
                :sending="sending"
                :uploadable="false"
                @send="$emit('start', $event)"
            />
        </template>
    </div>
</template>

<script>
    import ChatHeader from './ChatHeader.vue'
    import ChatMessages from './ChatMessages.vue'
    import ChatInput from './ChatInput.vue'
    import { CONVERSATION_MODE } from '../../utils/flexworkerConversation.js'
    import { pickedUpNote } from '../../utils/chatClaim.js'

    export default {
        name: 'ConversationPane',
        components: {
            ChatHeader,
            ChatMessages,
            ChatInput
        },
        props: {
            conversation: {
                type: Object,
                required: true
            },
            sending: {
                type: Boolean,
                required: true
            },
            sendFailure: {
                type: String,
                default: ''
            }
        },
        computed: {
            isDraft() {
                return this.conversation.mode === CONVERSATION_MODE.DRAFT;
            },
            isHistory() {
                return this.conversation.mode === CONVERSATION_MODE.HISTORY;
            },
            isReadOnly() {
                return this.conversation.mode === CONVERSATION_MODE.READ_ONLY;
            },
            canStartNew() {
                return this.isDraft || this.isHistory;
            },
            readOnlyNote() {
                const owner = this.conversation.chat.owner;

                return owner ? pickedUpNote(owner) : 'Waiting for a colleague in another department to pick it up';
            }
        }
    }
</script>

<style scoped>
    .messages-container {
        flex: 1 1 auto;
        overflow: auto;
        min-height: 0;
    }
    .conversation-note {
        color: #8d97ad;
        font-size: 1.2rem;
        font-style: italic;
    }
    .send-failure {
        color: #D32F2F;
        font-size: 1.2rem;
    }
</style>
